import ReactMarkdown from 'react-markdown';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';

/**
 * Post bodies are authored as markdown by league members, so everything is
 * sanitised before rendering. The schema is the rehype default plus the
 * attributes needed for inline images.
 */
const schema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    img: [...(defaultSchema.attributes?.['img'] ?? []), 'loading', 'width', 'height'],
  },
};

export function Markdown({ children }: { children: string }) {
  return (
    <div className="prose-gl">
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[[rehypeSanitize, schema]]}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
